import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=b54674be&scoped=true"
import script from "./SuperAdmin.vue?vue&type=script&lang=ts"
export * from "./SuperAdmin.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdmin.vue?vue&type=style&index=0&id=b54674be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54674be",
  null
  
)

/* custom blocks */
import block0 from "./SuperAdmin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports